import { Fragment, createElement } from 'react';

import { VStack, new__cn as cn } from '@/package';

type ToolbarGroupProps = {
  visibleDivider?: boolean;
};

const ToolbarGroup = ({
  className,
  children,
  visibleDivider,
}: React.PropsWithChildren<
  ToolbarGroupProps & React.ComponentPropsWithoutRef<'div'>
>) => {
  return createElement(
    visibleDivider ? VStack : Fragment,
    visibleDivider
      ? {
          className: 'gap-1 pb-1',
        }
      : null,
    [
      <VStack
        key={0}
        aria-label="toolbar-group"
        className={cn('w-9', className)}
        items="center"
        gap={0.125}
      >
        {children}
      </VStack>,
      visibleDivider && (
        <div key={1} className="mx-auto h-px w-[30px] bg-gray-300" />
      ),
    ],
  );
};

export default ToolbarGroup;
